export default {
  carWashDisputes: [],
  disputes: [],
  selectedDispute: undefined,
  currentPageNumber: 0,
  pageSize: 10,
  nextAvailablePage: undefined
}
